<template>
	<div>
		<div class="quota-summary">
			<div class="TopSearch" style="margin-top:16px;height:65px;">
				<FromComm :FromArr="FromArrS"></FromComm>
			</div>
			<div class="Table">
				<div class="table-title">
					医院IMS销售指标汇总表
				</div>
				<!--自定义表格-->
				<div class="custom-table">
					<div class="table-key">
						<div class="title-item" v-for="(item,index) in titleList" :key="index">
							<el-dropdown v-if="index&&item.title&&index!=3" trigger="click"
								@command="handComm($event,index)">
								<span class="el-dropdown-link" @click="handLoadData(item,index)">
									{{item.title}}<i class="el-icon-arrow-down el-icon--right"></i>
								</span>
								<el-dropdown-menu style="max-height: 300px;overflow-y: auto;" slot="dropdown">
									<el-dropdown-item v-for="(item1,index1) in item.options" :key="index1"
										:disabled="item1.disabled" :command="index1">
										{{item1.key}}
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
							<span class="el-dropdown-link" v-if="index&&item.title&&index==3" v-popover:popover
								@click="handLoadData(item,index)">
								{{item.title}}<i class="el-icon-arrow-down el-icon--right"></i>
							</span>
							<el-popover v-if="index&&item.title&&index==3" v-model="hospitalShow" ref="popover"
								placement="bottom" width="500" trigger="click">
								<el-input size="small" v-model="hospitalName" placeholder="输入医院名称"></el-input>
								<div class="btngroup">
									<CommonBtngroup ref="btngroup" :qhide="false" @select="getHospData"
										@reset="hospitalName = ''"></CommonBtngroup>
								</div>
								<el-table :data="item.options" style="cursor: pointer;" @row-click="handRowClick">
									<el-table-column width="500" property="key" label="医院名称"></el-table-column>
								</el-table>
								<div style="display: flex;justify-content: center;padding:10px 0px">
									<Pagination style="display: inline-block;" type='allColor' :pageSize="hospitalSize"
										layout="total, prev, pager, next" @handleCurrentChange="currentPage"
										@handleSizeChange="currentSize" :total="hospitalTotal">
									</Pagination>
								</div>
							</el-popover>
						</div>
					</div>
					<div class="table-value">
						<div class="value-item" v-for="(item,index) in titleList" :key="index">
							<template v-if="!index">
								{{item.val}}
							</template>
							<span class="item-val" v-else>
								{{item.val}}
							</span>
						</div>
					</div>
					<div class="table-value1">
						<div class="value-item" v-for="(item,index) in titleList" :key="index">
							<template v-if="!index">
								{{item.val1}}
							</template>
							<span class="item-val" v-else>
								{{item.val1}}
							</span>
						</div>
					</div>
					<div class="table-value2">
						<div class="value-item" v-for="(item,index) in titleList" :key="index">
							<template v-if="!index">
								{{item.val2}}
							</template>
							<span class="item-val" v-else>
								{{item.val2}}
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="quota-summary">
			<div class="BottomTable">
				<!--  v-if="qx.update" -->
				<Commonbtn v-if="auth.includes('edit')" backgroundColor="#FFF" title="修改" fontSize="14px"
					@btnclick="update" :src="require('@/assets/icon/icon-update.png')">
				</Commonbtn>
				<!--  v-if="qx.del" -->
				<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="exportFile"
					:src="require('@/assets/icon/daoc.png')">
				</Commonbtn>
			</div>
			<div class="TopSearch">
				<FromComm :FromArr="FromArr"></FromComm>
				<div class="btngroup">
					<CommonBtngroup ref="btngroup" :qhide="false" @select="handSearch" @reset="handReset">
					</CommonBtngroup>
				</div>
			</div>
			<div class="Table">
				<div class="table-title">
					医院IMS销售指标明细表
				</div>
				<Commontable ref="refTableCenter" @onRowClick="onRowClick" width="960px" colnum=7 :tableData="tableData"
					:headerData="headerData" height="100%">
				</Commontable>
				<div class="pagination">
					<Pagination ref="invPagination" type='allColor' :pageSize="query.pageSize"
						@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total">
					</Pagination>
				</div>
			</div>
			<DialogFrom width="1060px" :title="tableCurr?'修改':'新增'" :OKASCAN="true" :dialogVisible="dialogShow"
				@cancel="cancelEditor" @dialogOK="dialogOKEditor">
				<FromComm :FromArr="FromArrEditor" @remoteMethod="remoteMethod"
					@AuthorizedDealerChange="AuthorizedDealerChange"></FromComm>
			</DialogFrom>
		</div>
	</div>
</template>

<script>
	import FromComm from '../../../../components/fromComponents/Commfrom/from-comm.vue'
	import CommonBtngroup from '../../../../../../../components/commongroup.vue'
	import Commonbtn from '../../../../../../../components/common-btn.vue'
	import DialogFrom from '../../../../../../../components/dialog-from.vue'
	import Pagination from '../../../../../../../components/pagination.vue'
	import CommonbtnUpLoad from './../../../../../../../components/common-upload.vue'
	import Commontable from '../../../../../../../components/common-table.vue'
	import Dialog from '../../../../../../../components/dialog.vue'
	import FromArr from '../FormData/FromArrIms'
	import FromArrS from '../FormData/FromArrImsS'
	import FromArrEditorS from '../FormData/FromArrEditorImsS'
	import headerData from '../TableData/headerImsData'
	import utils from "../../../../../../../common/utils";
	import {
		InventoryClassList,
		HospitalList,
		GetProvince,
		GetHelperCountryMan,
		GetHelperAreaMan,
		GetHelperRegionMan,
		GetHelperSalesMan,
		HelperTechnicalOfficesList
	} from '@/api/home'
	import {
		HelperLEVEL3
	} from '@/api/channel'
	import {
		GetQuotaIMSSummary,
		GetQuotaIMSList,
		GetQuotaIMSInfo,
		ExportQuotaIMSInfo,
		EditQuotaIMS
	} from '@/api/newsapi'
	export default {
		props: {
			auth: Array
		},
		components: {
			FromComm,
			CommonBtngroup,
			Commonbtn,
			DialogFrom,
			Dialog,
			Pagination,
			CommonbtnUpLoad,
			Commontable
		},
		data() {
			return {
				total: 0,
				query: {
					pageIndex: 1,
					pageSize: 10
				},
				dialogShow: false,
				FromArr: [],
				FromArrS: [],
				FromArrEditor: [],
				tableCurr: null,
				tableData: [],
				headerData: [],
				tableDatadrjg: [],
				summaryData: [],
				query2: {},
				hospitalName: '',
				hospitalShow: false,
				hospitalPage: 1,
				hospitalSize: 10,
				hospitalTotal: 0,
				titleList: [{
					val: '汇总项',
					val1: '金额BP',
					val2: '数量BP'
				}, {
					title: '产品线',
					key: 'invClass',
					val: '',
					val1: '',
					val2: '',
					options: []
				}, {
					title: 'Level3',
					key: 'leveL3',
					val: '',
					val1: '',
					val2: '',
					options: []
				}, {
					title: '医院',
					key: 'hospital',
					val: '',
					val1: '',
					val2: '',
					options: []
				}, {
					title: '医院省份',
					key: 'provinceID',
					val: '',
					val1: '',
					val2: '',
					options: []
				}, {
					title: '销售-全国',
					key: 'countryMan',
					val: '',
					val1: '',
					val2: '',
					options: []
				}, {
					title: '销售-大区',
					key: 'areaMan',
					val: '',
					val1: '',
					val2: '',
					options: []
				}, {
					title: '销售-地区',
					key: 'regionMan',
					val: '',
					val1: '',
					val2: '',
					options: []
				}, {
					title: '销售-代表',
					key: 'salesMan',
					val: '',
					val1: '',
					val2: '',
					options: []
				}]
			}
		},
		mounted() {
			this.FromArr = JSON.parse(JSON.stringify(FromArr))
			this.FromArrS = JSON.parse(JSON.stringify(FromArrS))
			this.FromArrEditor = JSON.parse(JSON.stringify(FromArrEditorS))
			this.headerData = JSON.parse(JSON.stringify(headerData))
			this.inventoryClassList();
			this.HelperLEVEL3();
			this.getData();
		},
		methods: {
			async getData() {
				this.query.year = this.FromArr[0].modelvalue;
				this.query.invClass = this.FromArr[1].modelvalue;
				this.query.leveL3 = this.FromArr[2].modelvalue;
				this.query.hospital = this.FromArr[3].modelvalue;
				let {
					code,
					data
				} = await GetQuotaIMSList(this.query)
				if (code == 0) {
					this.total = data.Count;
					this.tableData = data.data;
				}
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({})
				if (code == 0) {
					this.FromArr[0].options = []
					this.FromArrS[0].options = []
					this.FromArr[1].options = []
					this.titleList[1].options = [];
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.FromArr[1].options.push(obj)
						this.FromArrEditor[1].options.push(obj)
						this.titleList[1].options.push({
							key: item.InvClassName,
							val: item.InvClass,
						})
					})
					let date = new Date()
					let yearArr = [
						date.getFullYear() - 1,
						date.getFullYear(),
						date.getFullYear() + 1
					]
					yearArr.map((item, index) => {
						let obj = {
							key: item,
							value: item
						}
						this.FromArr[0].options.push(obj)
						this.FromArrS[0].options.push(obj)
						this.FromArrEditor[0].options.push(obj)
					})
				} else {
					this.$message.error('公司加载失败')
				}
			},
			// 产品分类L3
			async HelperLEVEL3() {
				let {
					code,
					data,
					message
				} = await HelperLEVEL3({})
				if (code == 0) {
					this.FromArr[2].options = []
					this.FromArrEditor[2].options = []
					data.forEach((item, index) => {
						let obj = {
							key: item.key,
							value: item.value
						}
						this.FromArr[2].options.push(obj)
						this.FromArrEditor[2].options.push(obj)
					})
				}
			},
			handSearch() {
				this.query.pageIndex = 1;
				this.getData();
			},
			handReset() {
				this.query = {
					pageIndex: 1,
					pageSize: 10
				};
				this.FromArr.map((item, index) => {
					item.modelvalue = '';
				})
				this.getData();
			},
			onRowClick(val) {
				this.tableCurr = val.ID;
			},
			// 导出
			async exportFile() {
				if (this.FromArr[0].modelvalue) {
					this.query.year = this.FromArr[0].modelvalue;
				}
				if (this.FromArr[1].modelvalue) {
					this.query.invClass = this.FromArr[1].modelvalue;
				}
				if (this.FromArr[2].modelvalue) {
					this.query.leveL3 = this.FromArr[2].modelvalue;
				}
				if (this.FromArr[3].modelvalue) {
					this.query.hospital = this.FromArr[3].modelvalue;
				}
				let resexprot = await ExportQuotaIMSInfo(this.query);
				if (resexprot) {
					utils.downloadFile(resexprot, "指标汇总", "xlsx");
				} else {
					// 返回json
					this.$message.warning("导出失败");
				}
			},
			//编辑
			async update() {
				if (!this.tableCurr) {
					this.$message.error('请先选择数据');
					return;
				}
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					data
				} = await GetQuotaIMSInfo({
					id: this.tableCurr
				})
				if (code == 0) {
					this.FromArrEditor = this.FromArrEditor.map((item, index) => {
						item.modelValue = data.data[item.key];
						item.modelvalue = data.data[item.key];
						if (index === 3) {
							item.options = [{
								label: data.data.HPName,
								value: data.data.HPID
							}]
						}
						return item;
					})
					await this.loadTechnicalOfficesOptions(data.data.HPID)
					if (this.FromArrEditor[4]) {
						if (data.data.TechnicalOfficesID && data.data.TechnicalOfficesName && !this.FromArrEditor[4].options.some(
								item => item.key == data.data.TechnicalOfficesID)) {
							this.FromArrEditor[4].options.push({
								key: data.data.TechnicalOfficesID,
								value: data.data.TechnicalOfficesName
							})
						}
						this.FromArrEditor[4].modelvalue = data.data.TechnicalOfficesID || ''
					}
					this.dialogShow = true;
					this.$forceUpdate();
				}
				loading.close();
			},
			//模糊查询
			async remoteMethod(val) {
				let {
					code,
					data
				} = await HospitalList({
					HosType: "医院",
					hpName: val.qurey,
					pageIndex: 1,
					pageSize: 9999
				})
				if (code == 0) {
					this.FromArrEditor[3].options = []
					data.data.forEach((item, index) => {
						let obj = {
							label: item.HPName,
							value: item.HPID
						}
						this.FromArrEditor[3].options.push(obj)
					})
				}
			},
			async loadTechnicalOfficesOptions(hospitalId) {
				if (this.FromArrEditor[4]) {
					this.FromArrEditor[4].options = [];
				}
				if (!hospitalId) {
					return;
				}
				let {
					code,
					data
				} = await HelperTechnicalOfficesList({
					Hospital: Number(hospitalId)
				})
				if (code == 0 && this.FromArrEditor[4]) {
					this.FromArrEditor[4].options = (Array.isArray(data) ? data : []).map(item => {
						return {
							key: item.Value,
							value: item.Text
						}
					})
				}
			},
			async AuthorizedDealerChange() {
				if (this.FromArrEditor[4]) {
					this.FromArrEditor[4].modelvalue = '';
				}
				await this.loadTechnicalOfficesOptions(this.FromArrEditor[3].modelvalue);
			},
			//取消编辑
			cancelEditor() {
				this.FromArrEditor = this.FromArrEditor.map(item => {
					item.modelValue = undefined;
					item.modelvalue = '';
					return item;
				})
				this.tableCurr = null;
				this.dialogShow = false;
				this.$forceUpdate();
			},
			async dialogOKEditor() {
				let params = {};
				this.FromArrEditor.map(item => {
					params[item.key] = item.modelValue || item.modelvalue
				})
				params.id = this.tableCurr;
				let {
					code,
					data,
					message
				} = await EditQuotaIMS(params)
				if (code == 0) {
					this.tableCurr = null;
					this.$message('已修改');
					this.cancelEditor();
					this.handSearch();
				} else {
					this.$message.error(message);
				}
			},
			handleCurrentChange(e) {
				this.query.pageIndex = e
				this.getData()
			},
			handleSizeChange(e) {
				this.query.pageSize = e
				this.getData()
			},
			//顶部表格查询
			getSummary(query, callback) {
				query.year = this.FromArrS[0].modelvalue;
				query.month = this.FromArrS[1].modelvalue;
				GetQuotaIMSSummary(query).then(res => {
					let {
						code,
						data
					} = res
					if (code == 0) {
						callback(data);
					}
				})
			},
			handComm(e, i) {
				let params = {};
				this.query2[this.titleList[i].key] = this.titleList[i].options[e].val;
				this.titleList[i].val = this.titleList[i].options[e].key;
				if (i === 1) {
					params.invClass = this.query2.invClass;
				}
				if (i === 2) {
					params.leveL3 = this.query2.leveL3;
				}
				if (i === 4) {
					params.provinceID = this.query2.provinceID;
				}
				if (i === 5) {
					params.salesMan = this.query2.countryMan;
				}
				if (i === 6) {
					params.salesMan = this.query2.areaMan;
				}
				if (i === 7) {
					params.salesMan = this.query2.regionMan;
				}
				if (i === 8) {
					params.salesMan = this.query2.salesMan;
				}
				this.getSummary(params, res => {
					this.titleList[i].val1 = res.MoneyQuotaString;
					this.titleList[i].val2 = res.QuantityQuotaString;
				})
			},
			handLoadData(e, i) {
				if (!this.FromArrS[0].modelvalue || !this.FromArrS[1].modelvalue) {
					this.$message.error('请选择年份和月份');
					return;
				}
				let params = {};
				switch (i) {
					case 2:
						params.invClass = this.query2.invClass;
						HelperLEVEL3(params).then(res => {
							let {
								code,
								data
							} = res
							if (code == 0) {
								this.titleList[i].options = [];
								if (!data.length) {
									this.titleList[i].options.push({
										disabled: true,
										key: '无数据',
										val: '无数据',
									})
									return;
								}
								data.map((item, index) => {
									this.titleList[i].options.push({
										key: item.key,
										val: item.value,
									})
								})
							}
						})
						break;
					case 4:
						GetProvince({}).then(res => {
							let {
								code,
								data
							} = res
							if (code == 0) {
								this.titleList[i].options = [];
								if (!data.length) {
									this.titleList[i].options.push({
										disabled: true,
										key: '无数据',
										val: '无数据',
									})
									return;
								}
								data.map((item, index) => {
									this.titleList[i].options.push({
										key: item.Text,
										val: item.Value,
									})
								})
							}
						})
						break;
					case 5:
						params.invClass = this.query2.invClass;
						GetHelperCountryMan(params).then(res => {
							let {
								code,
								data
							} = res
							if (code == 0) {
								this.titleList[i].options = [];
								if (!data.length) {
									this.titleList[i].options.push({
										disabled: true,
										key: '无数据',
										val: '无数据',
									})
									return;
								}
								data.map((item, index) => {
									this.titleList[i].options.push({
										key: item.value,
										val: item.key,
									})
								})
							}
						})
						break;
					case 6:
						params.invClass = this.query2.invClass;
						params.ParentUserName = this.query2.countryMan
						GetHelperAreaMan(params).then(res => {
							let {
								code,
								data
							} = res
							if (code == 0) {
								this.titleList[i].options = [];
								if (!data.length) {
									this.titleList[i].options.push({
										disabled: true,
										key: '无数据',
										val: '无数据',
									})
									return;
								}
								data.map((item, index) => {
									this.titleList[i].options.push({
										key: item.value,
										val: item.key,
									})
								})
							}
						})
						break;
					case 7:
						params.invClass = this.query2.invClass;
						params.ParentUserName = this.query2.areaMan
						GetHelperRegionMan(params).then(res => {
							let {
								code,
								data
							} = res
							if (code == 0) {
								this.titleList[i].options = [];
								if (!data.length) {
									this.titleList[i].options.push({
										disabled: true,
										key: '无数据',
										val: '无数据',
									})
									return;
								}
								data.map((item, index) => {
									this.titleList[i].options.push({
										key: item.value,
										val: item.key,
									})
								})
							}
						})
						break;
					case 8:
						params.invClass = this.query2.invClass;
						params.ParentUserName = this.query2.regionMan
						GetHelperSalesMan(params).then(res => {
							let {
								code,
								data
							} = res
							if (code == 0) {
								this.titleList[i].options = [];
								if (!data.length) {
									this.titleList[i].options.push({
										disabled: true,
										key: '无数据',
										val: '无数据',
									})
									return;
								}
								data.map((item, index) => {
									this.titleList[i].options.push({
										key: item.value,
										val: item.key,
									})
								})
							}
						})
						break;
				}
			},
			//获取医院相关数据
			getHospData() {
				let params = {};
				params.HPName = this.hospitalName;
				params.HosType = '医院';
				params.pageIndex = this.hospitalPage;
				params.pageSize = this.hospitalSize;
				HospitalList(params).then(res => {
					let {
						code,
						data
					} = res
					if (code == 0) {
						this.titleList[3].options = [];
						data.data.map((item, index) => {
							this.titleList[3].options.push({
								key: item.HPName,
								val: item.HPID,
							})
						})
						this.hospitalTotal = data.Count;
						this.hospitalShow = true;
					}
				})
			},
			//当前行点击
			handRowClick(e) {
				let params = {};
				this.query2.hospital = e.val;
				this.titleList[3].val = e.key;
				this.getSummary(this.query2, res => {
					this.titleList[3].val1 = res.MoneyQuotaString;
					this.titleList[3].val2 = res.QuantityQuotaString;
					this.hospitalShow = false;
				})
			},
			currentPage(e) {
				this.hospitalPage = e
				this.getHospData()
			},
			currentSize(e) {
				this.hospitalSize = e
				this.getHospData()
			}
		}
	}
</script>

<style lang="less" scoped>
	.quota-summary {
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);

	}

	.TopSearch {
		height: 140px;
		margin: 0px 0px 8px;
		border-top: 1px solid #EEEEEE;


		.btngroup {
			// border: 1px solid #0b65ec;
			position: relative;
			bottom: 20px;
		}
	}

	.BottomTable {
		margin: 14px 0px 0px;
	}

	.Table {
		.table-title {
			font-size: 14px;
			font-family: Alibaba PuHuiTi 2.0-55 Regular, Alibaba PuHuiTi 20;
			font-weight: 500;
			color: #333333;
			padding: 0px 0px 16px 10px;
		}

		.custom-table {
			cursor: pointer;
			user-select: none;
			padding: 16px;
			box-sizing: border-box;

			.table-key {
				display: flex;

				.title-item {
					flex: 1;
					height: 40px;
					line-height: 40px;
					text-align: center;
					border: 1px solid #EEEEEE;
					box-sizing: border-box;
					background: #F9F9F9;
					border-bottom: 0px;
					border-right: 0px;

					.el-dropdown-link {
						font-size: 14px;
						font-family: Alibaba PuHuiTi 2.0-55 Regular, Alibaba PuHuiTi 20;
						font-weight: 500;
						color: #333333;
					}
				}

				.title-item:last-child {
					border-right: 1px solid #EEEEEE;
				}
			}

			.table-value {
				display: flex;

				.value-item {
					flex: 1;
					font-size: 14px;
					font-family: Alibaba PuHuiTi 2.0-55 Regular, Alibaba PuHuiTi 20;
					font-weight: 500;
					color: #333333;
					height: 40px;
					line-height: 40px;
					text-align: center;
					border: 1px solid #EEEEEE;
					box-sizing: border-box;
					border-right: 0px;
					border-bottom: 0px;

					.item-val {
						font-size: 10px;
						font-family: Alibaba PuHuiTi 2.0-55 Regular, Alibaba PuHuiTi 20;
						font-weight: 400;
						color: #666666;

						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						max-width: 94px;
						display: inline-block;
					}
				}

				.value-item:last-child {
					border-right: 1px solid #EEEEEE;
				}
			}

			.table-value1 {
				display: flex;

				.value-item {
					flex: 1;
					font-size: 14px;
					font-family: Alibaba PuHuiTi 2.0-55 Regular, Alibaba PuHuiTi 20;
					font-weight: 500;
					color: #333333;
					height: 40px;
					line-height: 40px;
					text-align: center;
					border: 1px solid #EEEEEE;
					box-sizing: border-box;
					border-right: 0px;
					border-bottom: 0px;

					.item-val {
						font-size: 14px;
						font-family: Alibaba PuHuiTi 2.0-55 Regular, Alibaba PuHuiTi 20;
						font-weight: 400;
						color: #333333;

						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						max-width: 94px;
						display: inline-block;
					}
				}

				.value-item:last-child {
					border-right: 1px solid #EEEEEE;
				}
			}

			.table-value2 {
				display: flex;

				.value-item {
					flex: 1;
					font-size: 14px;
					font-family: Alibaba PuHuiTi 2.0-55 Regular, Alibaba PuHuiTi 20;
					font-weight: 500;
					color: #333333;
					height: 40px;
					line-height: 40px;
					text-align: center;
					border: 1px solid #EEEEEE;
					box-sizing: border-box;
					border-right: 0px;

					.item-val {
						font-size: 14px;
						font-family: Alibaba PuHuiTi 2.0-55 Regular, Alibaba PuHuiTi 20;
						font-weight: 400;
						color: #333333;

						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						max-width: 94px;
						display: inline-block;
					}
				}

				.value-item:last-child {
					border-right: 1px solid #EEEEEE;
				}
			}
		}
	}
</style>
